import React from 'react';
import { GHGEmissions } from './GHGEmissions';
import { EnergyConsumption } from './EnergyConsumption';
import { EnergyIntensityRatio } from './EnergyIntensityRatio';
import { WaterConsumption } from './WaterConsumption';
import { WasteGenerated } from './WasteGenerated';
import { GenderSplit } from './GenderSplit';
import { GenderSplitPc } from './GenderSplitPc';
import { GenderPayGap } from './GenderPayGap';
import { AverageTraining } from './AverageTraining';
import { BoardGender } from './BoardGender';
import { BoardDiversity } from './BoardDiversity';
import { GenerateChartsProps } from '../common';

export const GenerateCharts = React.memo((props: GenerateChartsProps) => {
  return (
    <div style={{ height: 0, width: 0, overflow: 'hidden' }}>
      <GHGEmissions {...props} />
      <EnergyConsumption {...props} />
      <EnergyIntensityRatio {...props} />
      <WaterConsumption {...props} />
      <WasteGenerated {...props} />
      <GenderSplit {...props} />
      <GenderSplitPc {...props} />
      <GenderPayGap {...props} />
      <AverageTraining {...props} />
      <BoardGender {...props} />
      <BoardDiversity {...props} />
    </div>
  );
});
